import React from "react";

import Interweave from "interweave";

import styles from "./AboutUsComponent.module.css";

const AboutUsComponent = (props) => {
  const { data } = props;

  return (
    <section className={styles.band_about_us_container} id="band_about-us">
      <div className={styles.band_about_stiky_box}>
        <div className={styles.band_about_stiky_box_child}>
          <div className={styles.band_about_us_bg}></div>
        </div>
      </div>
      <div className={styles["container-fluid"]}>
        <div className="row ">
          <div
            className={`d-flex align-items-start col-lg-6 ${styles.about_sq_img}`}
          >
            <div className={styles.band_about_us_image_sticky}>
              <figure className="position-relative">
                <div className={styles.band_about_us_shadow}></div>
                <img
                  className={styles.band_about_us_image}
                  src={process.env.IMAGE_LINK + data?.image}
                  alt="band_about-us-img"
                />
              </figure>
            </div>
          </div>
          <div className={`col-lg-6 ${styles.band_about_us_content}`}>
            <h2 className={styles.band_about_us_content_heading}>About Us</h2>
            <div
              className={`d-flex flex-row flex-nowrap ${styles.band_about_us_content_title_wrapper}`}
            >
              <h3 className={styles.band_about_us_content_title}>
                {data?.title}
              </h3>
              <div className={styles.band_about_us_content_title_dash}></div>
            </div>
            <div className={styles.band_about_us_content_para}>
              <Interweave allowElements={false} content={data?.content} />
            </div>
            <div className={styles.band_about_us_shadow1}></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUsComponent;
